import { useCallback, useState } from "react";

type UseDisclosureProps = {
  defaultIsOpen?: boolean;
};

export const useDisclosure = (props?: UseDisclosureProps) => {
  const [isOpen, setIsOpen] = useState(props?.defaultIsOpen || false);
  const [params, setParams] = useState({});
  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onToggle = useCallback(() => setIsOpen((o) => !o), []);
  return { isOpen, onOpen, onClose, onToggle, params, setParams };
};

export type UseDisclosureReturn = ReturnType<typeof useDisclosure>;
